import { PDFDownloadLink } from '@react-pdf/renderer';
import Wedding from './../../components/pdf/Wedding';

const WeddingQuotationPDF = ({ pdfData }) => {

  const fileName = "WeddingQuotation.pdf";
  return (
    <div>
      <div className='download-link'>
        <PDFDownloadLink
          document={<Wedding pdfData={pdfData.quotation_details} mob_no_status={pdfData.mob_no_status} />}
          fileName={fileName}
        >
          <center><button className='text-light btn btn-sm btn-success m-3'>Download Quotation</button></center>
        </PDFDownloadLink>
      </div>
    </div>
  );
};

export default WeddingQuotationPDF;
